<template>
    <div>
        <el-dialog
                :close-on-click-modal="false"
                :title="'【'+name+'】调岗'"
                :visible.sync="show"
                width="500px" >
            <div style="width: 100%; height: 100%;" v-loading="loading">
                <div class="w100 pl20 pr20 pt20 pb20">
                    <el-form label-width="120px" :model="form" :rules="rules" ref="ruleForm" class="demo-form-inline">
                        <el-form-item label="原岗位名称：">
                            <el-input v-model="postName"  disabled></el-input>
                        </el-form-item>
                        <el-form-item label="新岗位名称：" prop="postId" >
                            <el-select v-model="form.postId"placeholder="请选择" class="w100">
                                <el-option
                                        v-for="item in list"
                                        :key="item.postId"
                                        :label="item.postName"
                                        :value="item.postId"
                                        :disabled="postId==item.postId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>

            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="submitForm('ruleForm')" type="primary">确 定</el-button>
                <el-button @click="show = false">取 消</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
    import { handleTransfer,getAllJobList} from '@/api/managementCenter/jobManage';

    export default {
        name: "switchJob",
        props: [],
        data() {
            return {
                show: false,
                loading: false,
                postName:"",
                name:"",
                postId:"",
                list:[],
                form: {
                    postId: "",
                    postUserId:""
                },
                rules: {
                    postId: [
                        { required: true, message: "请选择新岗位", trigger: "blur" }
                    ],
                }
            };
        },
        computed: {

        },
        mounted(){

        },
        methods: {
            getJobListFn(){
                getAllJobList().then(({data}) => {
                    if(data.code == 0){
                        this.list=data.data||[];
                    }else{
                        this.$message.warning( data.msg||"获取岗位失败！" );
                    }
                }).catch(err=>{
                })
            },

            // 显示弹框
            dialogShow (data) {
                this.show = true;
                this.$nextTick(()=>{
                    this.$refs["ruleForm"].resetFields();
                    this.postName=data.postName;
                    this.postId=data.postId;
                    this.form.postUserId=data.postUserId;
                    this.name=data.username;

                });
            },
            handleTransferFn(){
                this.loading = true;
                handleTransfer(this.form).then(({data})=>{
                    this.loading = false;
                    if(data.code == 0) {
                        this.$message.success(  "调岗成功!" );
                        this.show=false
                        this.$emit('saveSuccess')
                    }else{
                        this.$message.warning(  data.msg||"调岗失败!" );
                    }
                }).catch(err=>{
                    this.loading = false;
                    this.$message.error(  "服务器异常!" );
                })
            },

            // 确定提交
            submitForm (formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.handleTransferFn()
                    } else {
                        return false;
                    }
                });
            }
        },
        watch: {
            show(value){
                if(value){
                    this.getJobListFn()
                }
            }
        },
        filters: {}
    };
</script>

<style scoped lang="less">


</style>
